var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.$options.VBreadcrumbs,{key:_vm.data.key,tag:"component",staticClass:"i-breadcrumbs",attrs:{"items":_vm.props.items}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }